import { render } from "./CloneCohortModal.vue?vue&type=template&id=22e131de"
import script from "./CloneCohortModal.vue?vue&type=script&lang=js"
export * from "./CloneCohortModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__